import { Box, Container } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@tom-ui/planning'
import { Header, Loader, useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { messageBus, useYardStores } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { ContainerTurnoversReservationDialog } from './components/organisms/ContainerTurnoversReservationDialog'
import { ContainerTurnoversTable } from './components/organisms/ContainerTurnoversTable'
import { ContainerTurnoversUpdatePositionDialog } from './components/organisms/ContainerTurnoversUpdatePositionDialog'
import { ContainerTurnoverListViewStore } from './stores/container-turnover-list.view-store'

export const ContainerTurnovers = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { t } = useTranslate()
    const { containerJourneyItemStore } = usePlanningStore()
    const { yardBlockStore } = useYardStores()
    const listStore = useMemo(
      () =>
        new ContainerTurnoverListViewStore(containerJourneyItemStore, yardBlockStore, messageBus),
      [containerJourneyItemStore, yardBlockStore],
    )

    const { loading } = useAsyncFetch(async () => {
      await Promise.all([
        containerJourneyItemStore.fetchAll(),
        listStore.fetchOpenJourneyPositions(),
        yardBlockStore.loadYardBlocks(),
      ])
    }, [containerJourneyItemStore, listStore, yardBlockStore])

    if (loading) return <Loader show />

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <Header title={t('containerTurnovers', 'Container turnovers')} />

        <Container sx={{ my: theme.customSpacing.m }}>
          <ContainerTurnoversTable listStore={listStore} />
        </Container>

        <ContainerTurnoversReservationDialog listStore={listStore} />
        <ContainerTurnoversUpdatePositionDialog listStore={listStore} />
      </Box>
    )
  }),
)
